/**
 * Created by Administrator on 2018/6/12.
 */
const state = {
  title: '',
  homeTitle: ''
}
const mutations = {
  saveTitle(state, param){
    state.title = param
  },
  setHomeTitle(state, param){
    state.homeTitle = param
  }
}
const actions = {}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/currentTitle.js